<template>
  <div class="loader">
    <span class="bounce"></span>
    <span class="bounce"></span>
    <span class="bounce"></span>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1.0);
  }
}

.loader {
  padding: 18px 14px;
}
.bounce {
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 100%;
  display: inline-block;
  animation: bounce 1400ms infinite ease-in-out both;

  &:first-child {
    animation-delay: -320ms;
  }
  &:nth-child(2) {
    animation-delay: -160ms;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue